import * as Yup from "yup";

export const MIN_AMOUNT_ORG_1 = 100000;
export const MIN_AMOUNT_ORG_2 = 50000;

export const MIN_RETURN_AMOUNT_ORG_1 = 1500000;
export const MIN_RETURN_AMOUNT_ORG_2 = 100000;

interface MinAmounts {
  [key: string]: number;
}

const isNumberValid = (value: any) => {
  return /^[+-]?(\d+(\.\d+)?|\.\d+)([eE][+-]?\d+)?$/.test(value);
};



export const getMinAmountByOrganization = (organization: string, defaultMin: number): number => {
  const minAmounts: MinAmounts = { 
    '1': MIN_AMOUNT_ORG_1, 
    '2': MIN_AMOUNT_ORG_2 
  };
  return minAmounts[organization] || defaultMin;
};

export const getMinReturnAmountByOrganization = (organization: string): number => {
  const minReturnAmounts: MinAmounts = {
    '1': MIN_RETURN_AMOUNT_ORG_1,
    '2': MIN_RETURN_AMOUNT_ORG_2,
  };
  return minReturnAmounts[organization] || 0; 
};

export const getOrdersSchema  = (minAmount: number, minReturnAmount: number, contractTotalAmount: number) => Yup.object().shape({
  orderType: Yup.string().required("Выберите тип заявки"),

  selectedPeriod: Yup.string().when(["orderType"], ([orderType]) => {
    return orderType === "2ndfl"
      ? Yup.string().required(
          "Введите период, за который Вам нужна справка и повторите отправку заявления"
        )
      : Yup.string().notRequired();
  }),

  selectedContract: Yup.string().when(
    ["orderType", "returnType"],
    ([orderType, returnType]) => {
      if (
        orderType === "contractRefill" ||
        (orderType === "earlyReturn" &&
          (returnType === "partialReturn" || returnType === "fullLoan"))
      ) {
        return Yup.string()
          .required("Выберите договор")
          .notOneOf([""], "Договор не выбран");
      }
      return Yup.string().notRequired();
    }
  ),

  replenishmentAmount: Yup.number()
  .when("orderType", {
    is: (orderType: any) => orderType === "contractRefill",
    then: (schema) =>
      schema
        .min(minAmount, `Сумма должна быть не менее ${minAmount}`)
        .max(1000000000, "Максимальная сумма пополнения - 1 миллиард")
        .required("Введите сумму пополнения")
        .test('is-valid-number', 'Введите корректную сумму', isNumberValid),
    otherwise: (schema) => schema.notRequired(),
  }),


  returnType: Yup.string().when(["orderType"], ([orderType]) => {
    return orderType === "earlyReturn"
      ? Yup.string().required("Выберите тип возврата")
      : Yup.string().notRequired();
  }),

  returnAmount: Yup.number()
    .when(["orderType", "returnType", "selectedContract"], ([orderType, returnType, selectedContract]) => {
      if (orderType === "earlyReturn" && returnType === "partialReturn") {
        return Yup.number()
          .test('is-valid-number', 'Введите корректную сумму', isNumberValid)
          .max(contractTotalAmount - minReturnAmount, `Минимальный остаток займа по договору, при частичном возврате, должен составлять не менее ${minReturnAmount} рублей. Повторите ввод и отправьте заявление заново`)
          .required("Необходимо указать сумму возврата");
      } else {
        return Yup.number().notRequired();
      }
    }),

  capitalizedInterestAmount: Yup.number().when(["orderType", "returnType"], ([orderType, returnType], schema) =>
    orderType === "earlyReturn" && returnType === "capitalizedInterest" 
      ? schema.min(1, "Минимальная сумма для возврата должна быть больше 0. Повторите ввод и отправьте заявление заново").required("Заполните обязательно поле “Сумма возврата и повторите отправку") 
      : schema.notRequired()
  ),


  
});

export default getOrdersSchema ;
